module.exports = __webpack_public_path__ + "img/logo-controle-produtividade-comp.4b7f78a5.png";